import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { colors } from '../../../assets/styles/themes/variables';
import { selectPinnedCount } from '../../../reducers/pinned.selectors';
import useResponsivePadding from '../../../utils/useResponsivePadding';
import useRouter from '../../../utils/useRouter';
import getCollectionTabs from './getCollectionTabs';

interface CollectionsTabsProps {
	activeTab: string;
	isNewDesignEnabled?: boolean;
}

const CollectionsTabs: React.FC<CollectionsTabsProps> = (props) => {
	const { activeTab } = props;
	const { t } = useTranslation();
	const { router } = useRouter();
	const tabs = getCollectionTabs(t);
	const contentPadding = useResponsivePadding();
	const pinnedCount = useSelector(selectPinnedCount);
	const pinnedTitle = pinnedCount ? `${tabs.pinned.label} • ${pinnedCount}` : tabs.pinned.label;

	const isNewDesignEnabled = !!props.isNewDesignEnabled;
	const baseTabSx = isNewDesignEnabled ? { textTransform: 'none' } : {};
	const pinnedTabSx = isNewDesignEnabled ? { ...baseTabSx, paddingLeft: 0 } : baseTabSx;

	return (
		<Tabs
			value={activeTab}
			onChange={(_, newTab) =>
				router.push({
					pathname: `/${newTab}`,
				})
			}
			variant="scrollable"
			scrollButtons="auto"
			sx={{
				paddingLeft: isNewDesignEnabled ? contentPadding : 0,
				backgroundColor: colors.neutral0,
			}}
		>
			<Tab value={tabs.pinned.id} label={pinnedTitle} sx={pinnedTabSx} />
			<Tab value={tabs.ownCollections.id} label={tabs.ownCollections.label} sx={baseTabSx} />
			<Tab value={tabs.followedCollections.id} label={tabs.followedCollections.label} sx={baseTabSx} />
		</Tabs>
	);
};

export default CollectionsTabs;
